import { render, staticRenderFns } from "./activitySessionToLectureMapping.html?vue&type=template&id=62bd74b9&external"
import script from "./activitySessionToLectureMapping.vue?vue&type=script&lang=js"
export * from "./activitySessionToLectureMapping.vue?vue&type=script&lang=js"
import style0 from "./activitySessionToLectureMapping.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports